import React, { useEffect, useState } from 'react';
import { Button, Modal, Dropdown } from 'selfly-ui-react';

import './ConfirmButton.scss';

export default function ConfirmButton(props) {
    const { onClick, modalContent, children, title, labelOk, labelCancel, selectOptions, ...rest } = props;

    const [modalOpen, setModal] = useState(false);
    const [selectedOption, setSelectOption] = useState(null);

    useEffect(() => {
        if (selectOptions) {
            setSelectOption(selectOptions[0]);
        }
    }, [selectOptions]);

    function buttonClick() {
        setModal(true);
    }

    function closeModal() {
        setModal(false);
    }

    function confirm() {
        if (typeof onClick === 'function') {
            setModal(false);
            onClick(selectedOption);
        }
    }

    return (
        <React.Fragment>
            <Button onClick={buttonClick} {...rest}>
                {children}
            </Button>
            {modalOpen && selectOptions === undefined && (
                <div className="confirm-button-modal">
                    <Modal
                        active={modalOpen}
                        onClose={closeModal}
                        title={title !== undefined ? title : 'Are you sure?'}
                        actions={[
                            {
                                label: labelOk ? labelOk : 'OK',
                                onClick: confirm,
                            },
                            {
                                label: labelCancel ? labelCancel : 'Cancel',
                                onClick: closeModal,
                            },
                        ]}>
                        {modalContent}
                    </Modal>
                </div>
            )}
            {modalOpen && Array.isArray(selectOptions) && (
                <div className="confirm-button-modal">
                    <Modal
                        active={modalOpen}
                        onClose={closeModal}
                        title={title !== undefined ? title : 'Are you sure?'}
                        actions={[
                            {
                                label: labelOk ? labelOk : 'OK',
                                onClick: confirm,
                            },
                            {
                                label: labelCancel ? labelCancel : 'Cancel',
                                onClick: closeModal,
                            },
                        ]}>
                        {modalContent}
                        <div className="confirm-button-modal-select">
                            <Dropdown
                                className="modal-dropdown-options"
                                options={selectOptions}
                                value={selectedOption}
                                onChange={selectOption => setSelectOption(selectOption)}
                            />
                        </div>
                    </Modal>
                </div>
            )}
        </React.Fragment>
    );
}
